// src/hooks/useMediaQuery.js
//
// True while a CSS media query matches (e.g. '(max-width: 900px)'). Used where
// behaviour, not just layout, differs by width: the consultation's context
// drawer is a side panel on desktop and a modal bottom sheet on a phone.

import { useEffect, useState } from 'react';

const supported = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => (supported() ? window.matchMedia(query).matches : false));
  useEffect(() => {
    if (!supported()) return undefined;
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return matches;
}
